import { AuthorizationProps } from 'components/auth/Authorization/Authorization.types';
import { useAuthCode } from 'components/auth/Authorization/useAuthCode';
import { useNotification } from 'components/shared/hooks';
import { FullScreenLoader } from 'components/shared/loaders/FullScreenLoader/FullScreenLoader';
import { ROUTE_AUTH_LOGIN, ROUTE_ROOT } from 'config/routes';
import { push } from 'utils/navigation/navigate';
import React, { FC, useEffect } from 'react';

export const Authorization: FC<AuthorizationProps> = ({ authCode }) => {
  const { resolved, authorized, error } = useAuthCode(authCode);
  const { success, error: showError } = useNotification();

  useEffect(() => {
    if (resolved && authorized) {
      push(ROUTE_ROOT);
      success('AUTHORIZATION.NOTIFICATIONS.SIGN_IN_SUCCESS');
    }
  }, [resolved, authorized, success]);

  useEffect(() => {
    if (resolved && error) {
      push(ROUTE_AUTH_LOGIN);
      showError(error);
    }
  }, [resolved, showError, error, success]);

  return <FullScreenLoader />;
};
